<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none" value="1"> <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina Titlu="Raport penalizari" />
            </div>
          </template>
          <div class="filtre">
            <el-form @submit.prevent.native="refresh_info()">
              <el-row style="margin: 10px" class="input-group">
                <el-col class="input-element" :md="12" :sm="24">
                  <el-form-item label="Data deschidere" size="small" class="full-width">
                    <el-date-picker v-model="Filters.DataDeschiderii" type="daterange" range-separator="-" start-placeholder="Start"
                      :picker-options="datePickerOptions" end-placeholder="Sfarsit" value-format="yyyy-MM-dd" format="dd.MM.yyyy" style="width: 100%;">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col class="input-element" :md="12" :sm="24">
                  <el-form-item label="Numar auto" size="small">
                    <el-input v-model="Filters.NumarAuto" class="full-width" clearable placeholder="Ex: B123ABC" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element" :md="12" :sm="24">
                  <el-form-item label="Client"  size="small">
                    <el-input v-model="Filters.Client" class="full-width" clearable />
                  </el-form-item>
                </el-col>
                <el-col :md="24">
                  <el-button type="primary" size="mini" native-type="submit" icon="el-icon-search">
                    Cauta
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table :data="data" border style="width: 100%" v-loading="loading" size="small">
      <el-table-column label="Deviz" width="90" align="center">
        <template slot-scope="scope">
          <span>#{{ scope.row.IdDeviz }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Data deschidere" width="150" prop="DataDeschiderii">
        <template slot-scope="scope">
          {{scope.row.DataDeschiderii | DataOraFaraSec}}
        </template>
      </el-table-column>

      <el-table-column prop="MotivPenalizare" label="Motiv" min-width="200">
        <template slot-scope="scope">
          <span style="color:red; font-weight:bold;">{{ scope.row.MotivPenalizare }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Masina" width="245">
        <template slot-scope="scope">
          <span style="font-weight:bold;">{{ scope.row.NumarAuto }}</span>
          <span v-if="scope.row.NumeMarca || scope.row.NumeModel"> - {{ scope.row.NumeMarca }} {{ scope.row.NumeModel }}</span>
          <span v-if="scope.row.AnAuto" style="color:#888;"> ({{ scope.row.AnAuto }})</span>
        </template>
      </el-table-column>

      <el-table-column label="Client" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.NumeClient }} {{ scope.row.PrenumeClient }}</span>
          <span v-if="scope.row.TelefonClient" style="color:#888;"> - <i class="el-icon-phone-outline"></i> {{ scope.row.TelefonClient }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" fixed="right" label="Actiuni" width="66px">
        <template slot-scope="scope">
          <el-tooltip content="Preview deviz">
            <el-button type="primary" size="small" icon="el-icon-view" circle @click="preview(scope.row.IdDeviz)" />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager"
    />

    <Previewdeviz ref="preview_deviz" />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";
import Previewdeviz from '@/components/Preview_deviz';
import moment from 'moment';

export default {
  name: "Raport_devize_penalizate",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
    Previewdeviz,
  },
  data() {
    return {
      datePickerOptions: settings.datePickerOptions,
      data: [],
      Filters: {
        Client: "",
        NumarAuto: "",
        DataDeschiderii: [moment().subtract(1, 'months').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').toDate()],
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
      loading: false,
    };
  },
  methods: {
    async refresh_info() {
      this.loading = true;
      const filters = {
        ...this.Filters,
        DataDeschiderii: this.Filters.DataDeschiderii && this.Filters.DataDeschiderii.length === 2 
          ? [
              moment(this.Filters.DataDeschiderii[0]).format('YYYY-MM-DD'),
              moment(this.Filters.DataDeschiderii[1]).format('YYYY-MM-DD')
            ]
          : null
      };
      try {

        let response = await this.post("receptie/devize/get_raport_penalizari", { Filters: filters, OrderBy: this.OrderBy, PaginationInfo: this.PaginationInfo });

        if (response.Results) {
          this.data = response.Results;
        } else {
          this.data = [];
          this.$message.info("Nu au fost gasite devize penalizate in perioada selectata.");
        }
      } catch (e) {
        console.error(e);
        this.$message.error("Eroare la incarcarea datelor");
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      const z = n => (n < 10 ? '0' + n : n);
      return `${z(date.getDate())}.${z(date.getMonth() + 1)}.${date.getFullYear()}`;
    },

    async preview(id) {
      this.$refs.preview_deviz.show(id);
    },

  },
  async mounted() {
    this.base_url = settings.BASE_URL;
    await this.refresh_info();
  }
};
</script>
 <style lang="less" scoped>
  .top50 {
    margin-top: 20px;
  }
  
  .input-group {
    display: flex;
    align-items: flex-start;
  }
  
  .filtre {
    .el-input-number {
      width: 100% !important;
    }
    .el-input-date-picker {
      width: 100% !important;
    }
  }
  
  
  
  .total {
    width: 100%;
    background-color: white;
    padding: 14px 10px;
    text-align: end;
    font-size: 18px;
  }
  
  .input-element {
    width: 31%;
    margin-right: 2%;
  }
   .full-width {
        width: 100%;
    }
  
  @media only screen and (max-width: 600px) {
    .input-element {
      width: 80%;
      
    }
  
    .phone-btn {
      padding-left: 20px;
      position: -webkit-sticky;
      position: sticky;
      top: 0;
    }
  
    .input-group {
      margin: 10px;
    }
  
    .el-tooltip__popper {
      width: 90%;
    }
  
    .el-date-editor--daterange.el-input__inner {
      width: 300px;
    }
  
    .el-picker-panel__body {
      display: flex;
      flex-direction: column;
    }
  }
  </style>
  